import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDivider = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 0H0.0164023C0.273695 3.90902 3.52588 7 7.5 7C11.4741 7 14.7263 3.90902 14.9836 0H15V16H14.9836C14.7263 12.091 11.4741 9 7.5 9C3.52588 9 0.273695 12.091 0.0164023 16H0V0Z",
		fill: "#EEEEEE"
	})
});
export default SvgDivider;
